<template>
  <div class=''  >

    <div style='margin-bottom:24px;'>
      
      <el-tabs v-model="mode" @tab-click="handleClick">
        <el-tab-pane :label="$t('app_launchAnimate')" :name="$t('app_launchAnimate')"></el-tab-pane>
        <el-tab-pane :label="$t('app_onLogo')" :name="$t('app_onLogo')"></el-tab-pane>
        <el-tab-pane :label="$t('app_deskwp')" :name="$t('app_deskwp')"></el-tab-pane>
      </el-tabs>
    </div>

    <div class='gPageBorder'  v-if="mode === this.$t('app_launchAnimate')" name='main' v-loading='loading' style='overflow:hidden;'>
      <el-form class='gForm' label-position="right" ref="fm" :rules='addArules' label-width="12.5%" :model='fm' >
        <el-form-item :label="$t('app_name')" prop='name'>
          <el-input v-model="fm.name" :placeholder="$t('app_animateName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('app_playPlace')" prop='playPlace'>
          <el-select style='width:100%;' v-model="fm.playPlace" :placeholder="$t('app_select')">
            <el-option
              v-for="item in playPlace"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('app_animatefile')" prop='aFile'>

          <!-- <a class='aSc' style='' :href="downUrl" :title="$t('app_downExp')" target="_blank">{{$t('app_downExp')}}</a> -->

          <el-upload
            class="upload-demo"
            name='fileUpload'
            :action="fileUploadUrl"
            :before-upload="srcBefore"
            :on-success="srcSuccess"
            :file-list="srcList">
            <el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
            <!-- <div slot="tip" style='' class="el-upload__tip">{{$t('app_asfState')}}&nbsp;</div> -->
          </el-upload>
        </el-form-item>

        <!-- <el-form-item :label="$t('app_onLogo')" prop='onPic'>
          <el-upload
            class="upload-demo"
            accept='image/*'
            name="file"
            :action="imgUploadUrl"
            :before-upload="picBefore"
            :on-success="picSuccess"
            :on-error='picError'
            :file-list="picList">
            <el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
            <div slot="tip" class="el-upload__tip">{{$t('app_ologoState')}}</div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('app_picSize')" prop='picSize'>
          <el-input style='' v-model='fm.picSize' :placeholder="$t('app_picSizeState')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('app_frame')" prop='frame'>
          <el-input v-model='fm.frame' style='' :placeholder="$t('app_frameState')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('app_aCycleTime')" prop='playTimes'>
          <el-select style='' v-model="fm.playTimes" :placeholder="$t('app_select')">
            <el-option
              v-for="item in times"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item>
          <el-button  type='primary' style='' @click="addAnimate('fm', '1')">{{$t('app_customs')}}</el-button>
        </el-form-item>
      </el-form>
      
    </div>

    <div v-show="mode === this.$t('app_onLogo')" class='gPageBorder'>
      <el-form class='gForm' label-position="right" ref="fm1" :rules='addArules1' label-width="12.5%" :model='fm1' style=''>
        <el-form-item :label="$t('app_name')" prop='name'>
          <el-input v-model="fm1.name" placeholder="logo"></el-input>
        </el-form-item>
        <el-form-item label="LOGO" prop='pic'>
          <el-upload
            class="upload-demo"
            accept='*'
            name="fileUpload"
            :action="fileUploadUrl"
            :before-upload="picBefore"
            :on-success="picSuccess1"
            :on-error='picError1'
            :file-list="picList1">
            <el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
            <label style='color:#C0CCDA;'>{{$t('app_plsinputimgfile')}}</label>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button  type='primary' style='' @click="addAnimate('fm1', '2')">{{$t('app_customs')}}</el-button>
        </el-form-item>
      </el-form>
      
    </div>

    <div v-show="mode === this.$t('app_deskwp')" class='gPageBorder'>
      <el-form class='gForm' label-position="right" ref="fm2" :rules='addArules2' label-width="12.5%" :model='fm2' style=''>
        <el-form-item :label="$t('app_name')" prop='name'>
          <el-input v-model="fm2.name" :placeholder="$t('app_deskwp')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('app_pic')" prop='pic'>
          <el-upload
            class="upload-demo"
            accept='image/*'
            name="file"
            :action="imgUploadUrl"
            :before-upload="picBefore"
            :on-success="picSuccess2"
            :on-error='picError2'
            :file-list="picList2">
            <el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
            <label style='color:#C0CCDA;'>{{$t('app_plsUpl')}} {{$t('app_pic')}} (jpg/png, 720x1280)</label>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button  type='primary' style='' @click="addAnimate('fm2', '3')">{{$t('app_customs')}}</el-button>
        </el-form-item>
      </el-form>
      
    </div>

  </div>
</template>

<style>
  #aam{}
</style>

<script>
  export default{
    data () {
      var checkFrame = (rule, value, callback) => {
        if (!this.isNumber(value)) {
          callback(new Error(this.$t('app_inputNumber')));
        } else {
          callback()
        }
      }
      var checkSize = (rule, value, callback) => {
        var ar = value.split('*')
        if (ar.length === 2) {
          if (this.isNumber(ar[0]) && this.isNumber(ar[1])) {
            callback()
          } else {
            callback(new Error(this.$t('app_formatNotTrueLike') + '800*600'))
          }
        } else {
          callback(new Error(this.$t('app_formatNotTrueLike') + '800*600'))
        }
      }
      return {
        mode: this.$t('app_launchAnimate'), // 启动动画，开机LOGO
        loading: 0,
        md5: '',
        fm: {
          name: '',
          aType: '',
          playPlace: '',
          aFile: '',
          onPic: '',
          picSize: '720*1280',
          frame: '24',
          playTimes: ''
        },
        fm1: {
          name: '',
          pic: '',
          aType: ''
        },
        fm2: {
          name: '',
          pic: '',
          aType: ''
        },
        addArules: {
          name: [
            { required: true, message: this.$t('app_inputAnimateName'), trigger: 'blur' }
          ],
          aType: [
            { required: true, message: this.$t('app_selectAnimateType'), trigger: 'change' }
          ],
          playPlace: [
            { required: true, message: this.$t('app_selectPlayPlace'), trigger: 'change' }
          ],
          aFile: [
            { required: true, message: this.$t('app_uploadAnimateFile'), trigger: 'change' }
          ],
          onPic: [
            { required: true, message: this.$t('app_uploadOnPic'), trigger: 'blur' }
          ],
          picSize: [
            { required: true, trigger: 'blur', validator: checkSize}
          ],
          frame: [
            { required: true, trigger: 'blur', validator: checkFrame}
          ],
          playTimes: [
            { required: true, message: this.$t('app_chooseCycleType'), trigger: 'change' }
          ]
        },
        addArules1: {
          name: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          pic: [
            { required: true, message: this.$t('app_plsUpl'), trigger: 'change' }
          ]
        },
        addArules2: {
          name: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          pic: [
            { required: true, message: this.$t('app_uploadPic'), trigger: 'change' }
          ]
        },
        animateType: [
          {label: this.$t('app_launchAnimate'), value: '1'},
          {label: this.$t('app_launchUI'), value: '2'}
        ],
        playPlace: [
          {label: this.$t('app_on'), value: '1'},
          {label: this.$t('app_off'), value: '2'},
          {label: this.$t('app_onOff'), value: '3'}
        ],
        times: [
          {label: this.$t('app_playOnce'), value: '1'},
          {label: this.$t('app_cyclePlay'), value: '2'}
        ],
        srcList: [],
        picList: [],
        picList1: [],
        picList2: []
      }
    },
    components: {},
    computed: {
      imgUploadUrl () {
        // return this.$imgUploadUrl
        return this.$urls.picUrl
      },
      fileUploadUrl () {
        // return this.$fileUpImgloadUrl
         return this.$urls.fileUrl
      },
      downUrl () {
        return this.$host + '/tms-server-web/model/animation/part0.zip'
      }
    },
    methods: {
      isNumber (value) {
        var len = value.length
        var cLen = (parseInt(value) + '').length
        if (len === cLen) {
          return 1
        } else {
          return 0
        }
      },
      srcBefore (file) {
        // console.log(file)
        var name = file.name
        if (name) { //  === 'part0.zip'
          window[this.$route.path] = 1
          return true
        } else {
          this.$message(this.$t('app_fileNameOnly') + 'part0.zip')
          return false
        } 
      },
      srcSuccess (res, file) {
        window[this.$route.path] = ''
        console.log(res)
        if (res.status === 200) {
          this.md5 = res.md5
          this.srcList = [{name: file.name}]
          this.fm.aFile = res.fileUrl
          this.hBlur('fm')
        } else {
          this.srcList = []
        }
      },
      picBefore (file) {
        // console.log(file)
      },
      picError () {
        this.$message.error(this.$t('app_picUlError'))
        this.picList = []
      },
      picError1 () {
        this.$message.error(this.$t('app_picUlError'))
        this.picList1 = []
      },
      picError2 () {
        this.$message.error(this.$t('app_picUlError'))
        this.picList2 = []
      },
      picSuccess (res, file) {
        console.log('rr', res)
        if (res.status === 200) {
          this.picList = [{name: file.name}]
          this.fm.onPic = res.data
          this.hBlur('fm')
        } else {
          this.picList = []
        }
      },
      picSuccess1 (res, file) {
        console.log('rr1', res)
        if (res.status === 200) {
          this.picList1 = [{name: file.name}]
          this.fm1.pic = res.fileUrl
          this.md5 = res.md5
          this.hBlur('fm1')
        } else {
          this.picList1 = []
        }
      },
      picSuccess2 (res, file) {
        console.log('rr1', res)
        if (res.status === 200) {
          this.picList2 = [{name: file.name}]
          this.fm2.pic = res.data
          this.hBlur('fm1')
        } else {
          this.picList2 = []
        }
      },
      addAnimate (formName, anmtype) {
       
        
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (anmtype == '2') {
              // console.log(this.fm)
              var md = this.fm1
              this.loading = 1
              this.$addAnimate(this.md5, md.name, anmtype, '', md.pic, '', '', '', '', (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.$router.go(-1)
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              }) 
            } else if (anmtype == '1') {
              // console.log(t)
              var md = this.fm
              this.loading = 1
              this.$addAnimate(this.md5, md.name, anmtype, md.playPlace, md.aFile, md.picSize, md.frame, md.playTimes, md.onPic, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.$router.go(-1)
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              }) 
            } else {
              var md = this.fm2
              this.loading = 1
              this.$addAnimate(this.md5, md.name, anmtype, '', md.pic, '', '', '', '', (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.$router.go(-1)
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              }) 
            }
          } else {
            return false
          }
        })
      },
      hBlur (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
          } else {
            return false
          }
        })
      }
    },
    mounted () { 
    }
  }
</script>



// WEBPACK FOOTER //
// addAnimate.vue?7e938a6d